import commitmentPortrait from '../assets/portraits/brown1.jpg';
import { about } from '../data/copy';

function About() {
  return (
    <section className="commitment-section" id="about">
      <h2>{about.heading}</h2>
      <div className="commitment-content">
        <div className="commitment-text">
          {about.paragraphs.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
        <div className="commitment-image-container">
          <img
            src={commitmentPortrait}
            alt="Commitment Portrait"
            className="commitment-image"
          />
        </div>
      </div>
    </section>
  );
}

export default About;
